import React from 'react'
import StringEditor from './stringEditor'

const MemoEditor = (props) => (
  <StringEditor
    width={600}
    multiLine
    rows={5}
    commitButtonsInline={false}
    {...props}
  />
)

MemoEditor.propTypes = StringEditor.propTypes
export default MemoEditor
